import type { IReadAllParams } from "@/services/RequestParams";
import { TIME_RANGE_MAP } from "../../../config";
import type {
	SectorsChartType,
	SectorsTimeRange,
	SectorsType,
} from "../../../types";

export function createParams(
	ticker: SectorsType,
	timeRange: SectorsTimeRange,
	chartType: SectorsChartType,
): IReadAllParams {
	const timeRangeConfig = TIME_RANGE_MAP[timeRange];
	const currentTime = Date.now();

	return {
		fields:
			chartType === "Price"
				? timeRangeConfig.fields
				: timeRangeConfig.rmrFields,
		filter: [
			{ name: "ticker", condition: "eq", value: ticker },
			{
				name: "date",
				condition: "gte",
				value: currentTime - timeRangeConfig.duration,
			},
			{ name: "date", condition: "lte", value: currentTime },
		],
		sort: [{ name: "date", order: 1 }],
		types: { date: "date" },
	};
}
